import * as React from "react";
function SvgApp(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 3H3v8h8V3zM5 9V5h4v4H5zm6 4H3v8h8v-8zm-6 6v-4h4v4H5zm8-6h8v8h-8v-8zm2 2v4h4v-4h-4zm6-12h-8v8h8V3zm-6 6V5h4v4h-4z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgApp);
export default ForwardRef;
